import { PAY_STATUS, PAY_METHOD } from "@/lib/util";
import { tr as t } from "@/lib/i18n";

const COLORS = { unpaid: "border-red-500 bg-red-50 text-red-700", partial: "border-orange-500 bg-orange-50 text-orange-700", paid: "border-green-600 bg-green-50 text-green-700" };

export default function PaymentPicker({ value, onChange }) {
  const set = (k, v) => onChange({ ...value, [k]: v });
  return (
    <div className="space-y-4">
      <div>
        <div className="font-bold mb-2">{t("حالة الدفع")}</div>
        <div className="grid grid-cols-3 gap-2">
          {Object.entries(PAY_STATUS).map(([k, l]) => (
            <button type="button" key={k} data-testid={`pay-status-${k}`} onClick={() => set("payment_status", k)}
              className={`min-h-14 rounded-xl border-2 font-bold px-1 ${value.payment_status === k ? COLORS[k] : "border-slate-200 bg-white text-slate-600"}`}>{t(l)}</button>
          ))}
        </div>
      </div>
      {value.payment_status === "partial" && (
        <label className="block">
          <span className="font-bold mb-2 block">{t("المبلغ المحصل (د.ك)")}</span>
          <input data-testid="pay-partial-amount" className="field ltr text-left" inputMode="decimal" placeholder="0.000"
            value={value.paid_amount} onChange={(e) => set("paid_amount", e.target.value)} />
        </label>
      )}
      {value.payment_status !== "unpaid" && (
        <div>
          <div className="font-bold mb-2">{t("طريقة الدفع")}</div>
          <div className="grid grid-cols-4 gap-2">
            {Object.entries(PAY_METHOD).map(([k, l]) => (
              <button type="button" key={k} data-testid={`pay-method-${k}`} onClick={() => set("payment_method", k)}
                className={`h-12 rounded-xl border-2 font-bold ${value.payment_method === k ? "border-orange-500 bg-orange-50 text-orange-700" : "border-slate-200 bg-white text-slate-600"}`}>{t(l)}</button>
            ))}
          </div>
          {value.payment_method === "link" && <p className="text-sm text-orange-700 mt-2">{t("إرسال رابط الدفع لا يعني أن المبلغ تم تحصيله. ستؤكد الإدارة التحصيل لاحقاً.")}</p>}
        </div>
      )}
    </div>
  );
}
